// The tax line for a store-config "Taxes" charge — the ONE rule shared with
// the POS (dineplatform-pos src/services/pricing.ts applyTaxOperation) and the
// pool (pool-order-processing intent.ts taxFromCharge):
//   • tax added on top (US sales tax, VAT "added at payment"): rate × base
//   • tax INCLUDED in prices (UK VAT): the tax inside the base,
//     base × rate/(100 + rate) — £24.00 at 20% contains £4.00, not £4.80
//     (until 2026-09-23 the included case used rate × base: VAT overstated
//     by a fifth)
//   • flat ("+"): the amount as set
// `taxable` is the base the store taxes: cart taxable amount (takeaway
// exemptions already applied) + non-tax charges.

export interface TaxChargeLike {
    operation?: string;
    amount?: number | string;
    base?: number | string;
    taxIncludedInPrice?: boolean;
}

// Half-up to pence with sub-cent float noise stripped first — identical to
// CartComponent's round(), the pool's round() and the POS round2().
const round2 = (n: number) => {
    const cents = Math.round(n * 100 * 1e6) / 1e6;
    return Math.round(cents) / 100;
};

export function taxFromCharge(charge: TaxChargeLike, taxable: number): number {
    const amount = Number(charge.amount) || 0;
    const base = Number(charge.base || 0);
    const included = charge.taxIncludedInPrice === true;
    if (charge.operation === "%") {
        return round2(base + (included ? (taxable * amount) / (100 + amount) : (taxable * amount) / 100));
    }
    if (charge.operation === "*") {
        return round2(base + (included ? (taxable * amount) / (1 + amount) : taxable * amount));
    }
    if (charge.operation === "+") return round2(amount);
    return 0;
}
